import { Body } from "../body/Body";
import { BorderBar, Container, Content, Props } from "./Tab.Parts";

export const Tab = ({ $active, className, label, ...props }: Props) => (
  <Container $active={$active} className={className} {...props}>
    <Content>
      {typeof label === "string" ? (
        <Body variant="normal-strong">{label}</Body>
      ) : (
        label
      )}
    </Content>
    <BorderBar $active={$active} />
  </Container>
);
